export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.helektrika.bigquiz";

export const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/bigquiz-app/id6751693806";

export const BIGQUIZ_PROFILE_URL = "bigquiz://profile";
